import { DoubleSide, Layers, Vector2, Vector3 } from "three";
import { LineSegments2 } from 'three/addons/lines/LineSegments2.js';
import { LineGeometry } from 'three/addons/lines/LineGeometry.js';
import { LineMaterial } from 'three/addons/lines/LineMaterial.js';

import SceneGeometry from "./SceneGeometry";
import RefLineData from '../sceneObjectData/RefLineData';
import { areVectorsEqualWithinTolerance } from "../../utils/geometryUtils";
import Constants from "../../constants";
import LineSegment3d from "../../math/linearAlgebra/lineSegment3d";
import LayerMappingsEnum from "../../enums/LayerMappingsEnum";
import { RenderOrderEnum } from "../../enums/RenderOrderEnum";

export default class RefLineGeometry extends SceneGeometry<RefLineData> {
    
    refLineGeometry: LineGeometry;
    refLine: LineSegments2;

    refLineMaterial = new LineMaterial({  color: 0x009e2e,
                                            linewidth: 1, // Stroke thickness
                                            resolution: new Vector2(window.innerWidth, window.innerHeight),
                                            dashed: true,
                                            dashSize: 0.03,
                                            gapSize: 0.05,
                                            depthTest: false,
                                            depthWrite: false });

    constructor() {
        super();
        
        this.refLineGeometry = new LineGeometry();
        this.refLine = new LineSegments2(this.refLineGeometry, this.refLineMaterial);
        this.refLine.renderOrder = RenderOrderEnum.ReferenceLine;
        this.group.layers.set(LayerMappingsEnum.ReferenceLine);
        this.group.add(this.refLine);
    }

    updateGeometry(data: RefLineData): boolean {
        
        let isUpdated = this.updateLineDimensions(data); // Update line dimensions

        // Update data reference only if the geometry was updated            
        if (isUpdated) {
            this.data = data.clone(); // Update the data reference
        }

        return isUpdated;
    }

    updateLineDimensions(newData: RefLineData): boolean {

        if (this.data && this.data.line.equal(newData.line, Constants.INPUT_COMMAND_IS_PARALLEL_TOLERANCE))
            return false; // if line dimensions are the same, no need to update

        const offset = newData.line.getDirection(new Vector3).multiplyScalar(100);

        const dimensionLine = new LineSegment3d(    newData.line.getOrigin(new Vector3).add(offset),
                                                    newData.line.getOrigin(new Vector3).add(offset.clone().negate()));
    
        this.refLineGeometry.setPositions(dimensionLine.points().flatMap(pt => [pt.x, pt.y, pt.z]));
        this.refLine.computeLineDistances();

        return true;
    }

}